import {
    AsyncResult,
    callActionOrExecute,
    CommerceProperty,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';

export interface IProductRelationTypeForProduct {
    ProductId?: number;
    Name?: string;
    RecordId?: number;
    ExtensionProperties?: CommerceProperty[];
}

export class ProductRelationTypeForProductExtensionClass implements IProductRelationTypeForProduct {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ProductId: number;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Name: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public RecordId: number;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ExtensionProperties: CommerceProperty[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ProductId = odataObject.ProductId ? parseInt(odataObject.ProductId, 10) : 0;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Name = odataObject.Name;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.RecordId = odataObject.RecordId ? parseInt(odataObject.RecordId, 10) : 0;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ExtensionProperties = undefined;
        if (odataObject.ExtensionProperties) {
            this.ExtensionProperties = [];
            for (var i = 0; i < odataObject.ExtensionProperties.length; i++) {
                if (odataObject.ExtensionProperties[i]) {
                    if (odataObject.ExtensionProperties[i]['@odata.type']) {
                        var className: string = odataObject.ExtensionProperties[i]['@odata.type'];
                        className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
                        if (EntityClasses[className]) {
                            this.ExtensionProperties[i] = new EntityClasses[className](odataObject.ExtensionProperties[i]);
                        }
                    } else {
                        this.ExtensionProperties[i] = new EntityClasses.CommercePropertyClass(odataObject.ExtensionProperties[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.ExtensionProperties[i] = undefined;
                }
            }
        }
    }
}

function getRelationTypesByIdsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export enum SupportedRelationTypes {
    AlternativeProducts = 'AlternativeProducts',
    ReplacementSoft = 'ReplacementSoft',
    ReplacementHard = 'ReplacementHard'
}

export function getRelationTypesByIdsInput(
    queryResultSettings: IQueryResultSettings,
    productIds: number[],
    channelId: number,
    catalogId: number
): IDataServiceRequest {
    queryResultSettings.Paging = { Top: 1000, Skip: 0 };
    queryResultSettings.count = true;
    const query = getRelationTypesByIdsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetRelationTypesByIds',
        true,
        ProductRelationTypeForProductExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'ProductRelationTypeForProductExtensionClass' },
        {
            productIds: productIds,
            channelId: channelId,
            catalogId: catalogId
        }
    );
}

export function getRelationTypesByIdsAsync(
    context: IContext,
    productIds: number[],
    channelId: number,
    catalogId: number
): AsyncResult<IProductRelationTypeForProduct[]> {
    const request = getRelationTypesByIdsInput(context.queryResultSettings || {}, productIds, channelId, catalogId);
    return callActionOrExecute<IProductRelationTypeForProduct[]>(request, context.callerContext);
}
